import { Redirect } from "react-router-dom";

import { Loader } from "@transfr-inc/dashboard-components";
import {
  PageHeader,
  PageLayout,
} from "@transfr-inc/dashboard-components/layouts";

import { ProgramsEntryCards } from "@components/custom/programs";
import { RootPath } from "@lib/routes.config";
import {
  useOrganizationPrograms,
  useOrganizationProgramsEnabled,
} from "@queries/programs";

import "./index.scss";

const Programs = () => {
  const flag = useOrganizationProgramsEnabled();
  const enabled = flag.data === true;
  const {
    data: programs,
    isLoading,
    isError,
  } = useOrganizationPrograms({ selected: true }, { enabled });

  const count = programs?.length ?? 0;

  const pageHeader = (
    <PageHeader
      title="Programs"
      subTitle="The Transfr and custom programs your organization has chosen. Instructors pick from these when they set up a classroom."
      badge={count || undefined}
    />
  );

  const renderContent = () => {
    if (isLoading) {
      return <Loader fixed overlay />;
    }

    if (isError) {
      return (
        <div className="programs-message">
          Programs could not be loaded. Please try again.
        </div>
      );
    }

    if (count === 0) {
      return (
        <div className="programs-empty-state">
          <div className="programs-empty-state-message">
            There are no programs for this organization yet. Add one below.
          </div>
          <ProgramsEntryCards />
        </div>
      );
    }

    // Placeholder until the Programs table replaces it.
    return (
      <ul className="programs-list">
        {programs.map((program) => (
          <li key={program.templateId}>
            <span className="programs-list-title">{program.title}</span>
            {program.description && (
              <span className="programs-list-description">
                {program.description}
              </span>
            )}
          </li>
        ))}
      </ul>
    );
  };

  if (flag.isSuccess ? !enabled : flag.isError) {
    return <Redirect to={RootPath} />;
  }
  if (!enabled) {
    return <Loader fixed overlay />;
  }

  return (
    <PageLayout header={pageHeader} className="programs-page">
      {renderContent()}
    </PageLayout>
  );
};

export default Programs;
